import { render, staticRenderFns } from "./ProductGradeTile.vue?vue&type=template&id=62476f76"
import script from "./ProductGradeTile.vue?vue&type=script&lang=js"
export * from "./ProductGradeTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports